export default function setup() {
  $(document).ready(function () {
    $(document).on("click", ".forgot-password-link", function () {
      // Changed to class selector
      var $container = $(".forgot-password-form-container");
      if ($container.is(":empty")) {
        $.ajax({
          url: "/PasswordRecovery/RequestRecoveryEmailLite",
          type: "GET",
          success: function (response) {
            $container.html(response);
            // No need to re-initialize handlers with delegation
          },
          error: function (error) {
            console.error("Error loading the form:", error);
          },
        });
      } else {
        $container.empty();
      }
    });

    // Add event delegation for password recovery form submission
    $(document).on("click", "#send-password-button", function () {
      // Delegated event
      var form = $("#RequestRecoveryEmail");
      var formData = form.serialize();

      $.ajax({
        url: "/PasswordRecovery/RequestRecoveryEmailLite",
        type: "POST",
        data: formData,
        success: function (response) {
          $(".forgot-password-form-container").html(response);
        },
        error: function (xhr, status, error) {
          console.log("Error occurred: " + error);
        },
      });
    });

    // Function to validate the form
    function validateForm() {
      const $form = $("#registerNewPrivateSellerForm");
      const $submitButton = $("#register-new-private-user");
      const firstName = $form.find('input[name="FirstName"]').val()?.trim();
      const lastName = $form.find('input[name="LastName"]').val()?.trim();
      const email = $form.find('input[name="Email"]').val()?.trim();
      const password = $form.find('input[name="Password"]').val()?.trim();
      const consentChecked = $form
        .find('input[name="ConsentAgreement"]')
        .is(":checked");

      // Enable the button only if all fields are filled and consent is checked
      $submitButton.prop(
        "disabled",
        !(firstName && lastName && email && password && consentChecked)
      );
    }
    // Updated validateForm function
    function validateDealerForm() {
      const $form = $("#registerNewDealerForm");
      const $submitButton = $("#register-new-dealer");

      const dealershipName = $form
        .find('input[name="DealershipName"]')
        .val()
        ?.trim();
      const email = $form.find('input[name="Email"]').val()?.trim();
      const password = $form.find('input[name="Password"]').val()?.trim();
      const address = $form.find('input[name="Address"]').val()?.trim();
      const city = $form.find('input[name="City"]').val()?.trim();
      const zipCode = $form.find('input[name="ZipCode"]').val()?.trim();
      const consentChecked = $form
        .find('input[name="ConsentAgreement"]')
        .is(":checked");

      // Enable the button only if all fields are filled and consent is checked
      $submitButton.prop(
        "disabled",
        !(
          dealershipName &&
          email &&
          password &&
          address &&
          city &&
          zipCode &&
          consentChecked
        )
      );
    }

    $("#forgotPassword").on("click", function () {
      var $container = $(".forgot-password-form-container");
      // Make an AJAX call to load the form from the controller
      if ($container.is(":empty")) {
        $.ajax({
          url: "/PasswordRecovery/RequestRecoveryEmailLite", // Replace 'ControllerName' with your actual controller
          type: "GET",
          success: function (response) {
            // Load the form into the container
            $(".forgot-password-form-container").html(response);
            initializePasswordRecoveryFormHandlers();
          },
          error: function (error) {
            console.error("Error loading the form:", error);
          },
        });
      } else {
        // If the form is already displayed, clear the container and hide the form
        $container.empty(); // Clear the container
      }
    });

    function initializePasswordRecoveryFormHandlers() {
      $("#send-password-button").on("click", function () {
        // Collect the form data
        var form = $("#RequestRecoveryEmail");
        var formData = form.serialize();

        // Send the form via AJAX
        $.ajax({
          url: "/PasswordRecovery/RequestRecoveryEmailLite", // The action method that handles the form submission
          type: "POST",
          data: formData,
          success: function (response) {
            $(".forgot-password-form-container").html(response);
            initializePasswordRecoveryFormHandlers();
          },
          error: function (xhr, status, error) {
            // Handle errors (e.g., validation issues)
            console.log("Error occurred: " + error);
          },
        });
      });
    }

    $("#boat-dealer").on("click", function () {
      // Make an AJAX call to load the form from the controller
      $.ajax({
        url: "/Registration/RegisterDealer", // Replace 'ControllerName' with your actual controller
        type: "GET",
        success: function (response) {
          // Load the form into the container
          $(".register-form-container").html(response);
          initializeDealerFormHandlers();
        },
        error: function (error) {
          console.error("Error loading the form:", error);
        },
      });
    });

    $("#private-seller").on("click", function () {
      loadPrivateSellerPage();
    });

    function loadPrivateSellerPage() {
      // Make an AJAX call to load the form from the controller
      $.ajax({
        url: "/Registration/Register", // Replace 'ControllerName' with your actual controller
        type: "GET",
        success: function (response) {
          // Load the form into the container
          $(".register-form-container").html(response);
          initializeFormHandlers();
        },
        error: function (error) {
          console.error("Error loading the form:", error);
        },
      });
    }

    function initializeDealerFormHandlers() {
      const $form = $("#registerNewDealerForm");
      // Add event listeners to all input fields and the checkbox
      $form
        .find(
          'input[name="DealershipName"], input[name="Email"], input[name="Password"], input[name="Address"], input[name="City"], input[name="ZipCode"]'
        )
        .on("input", validateDealerForm);
      $form
        .find('input[name="ConsentAgreement"]')
        .on("change", validateDealerForm);
      validateDealerForm();
      // Custom submit button click event
      $("#register-new-dealer").on("click", function () {
        // Collect the form data
        var formData = $form.serialize();

        // Send the form via AJAX
        $.ajax({
          url: "/Registration/RegisterDealer", // The action method that handles the form submission
          type: "POST",
          data: formData,
          success: function (response) {
            if (response && response.redirectUrl) {
              window.location.href = response.redirectUrl;
              return;
            }
            initializeDealerFormHandlers();
          },
          error: function (xhr, status, error) {
            // Handle errors (e.g., validation issues)
            console.log("Error occurred: " + error);
          },
        });
      });
    }

    function initializeFormHandlers() {
      const $form = $("#registerNewPrivateSellerForm");
      // Add event listeners to all input fields and the checkbox
      $form
        .find(
          'input[name="FirstName"], input[name="LastName"], input[name="Email"], input[name="Password"]'
        )
        .on("input", validateForm);
      $form.find('input[name="ConsentAgreement"]').on("change", validateForm);
      validateForm();
      // Custom submit button click event
      $("#register-new-private-user").on("click", function () {
        // Collect the form data
        var formData = $("#registerNewPrivateSellerForm").serialize();

        // Send the form via AJAX
        $.ajax({
          url: "/Registration/Register", // The action method that handles the form submission
          type: "POST",
          data: formData,
          success: function (response) {
            if (response && response.redirectUrl) {
              window.location.href = response.redirectUrl;
              return;
            }
            // If failed (HTML), replace the form and reinit handlers
            $(".register-form-container").html(response);
            initializeFormHandlers();
          },
          error: function (xhr, status, error) {
            // Handle errors (e.g., validation issues)
            console.log("Error occurred: " + error);
          },
        });
      });
    }

    loadPrivateSellerPage();
  });
}
